import React from 'react';

import { getBasketCategoryPrestationsList } from '@front/common/src/utils/basket';
import { BasketContentItemWithPrices, Universe } from '@front/common/src/types/commons';

import Text from '@front/web-ui/src/components/base-text/variants/text';

import { CategoryLine, PrestationsList, PriceLine } from '../common';

import PrestationItem from './prestation-item';

type CategoryProps = {
  basketContentItem: BasketContentItemWithPrices;
  title: string;
  universe: Universe;
};

const Category = ({ basketContentItem, title, universe }: CategoryProps) => {
  const prestations = getBasketCategoryPrestationsList(
    basketContentItem.reference,
    universe,
    basketContentItem.prestations,
  );

  return (
    <CategoryLine>
      <PriceLine>
        <Text.MDBold>{title}</Text.MDBold>
      </PriceLine>
      <PrestationsList>
        {prestations.map((prestation, index) => (
          <PrestationItem
            key={prestation?.reference || index}
            prestation={prestation}
            price={prestation && basketContentItem.prestationsPrices[prestation.reference]}
          />
        ))}
      </PrestationsList>
    </CategoryLine>
  );
};

export default Category;
